import React from "react";
import {
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    CircularProgress,
    Checkbox,
} from "@mui/material";

import DialogModel from "components/DialogModel/DialogModel";
import { ConvertToTitleCase, FormatDate } from "commonFunctions/commonFunctions";
import TablePage from "components/TablePage/TablePage";

const EhrAppointmentsTable = (props) => {
    return <div className="appointment-data-section">
    <TableContainer component={Paper} className='appointment-table' >
        <Table stickyHeader aria-label="customized table">
            <TableHead className="thBorder">
                <TableRow>
                    <TableCell className="tableHeadStyle">Select</TableCell>
                    <TableCell className="tableHeadStyle">S.no</TableCell>
                    <TableCell className="tableHeadStyle">CSN</TableCell>
                    <TableCell className="tableHeadStyle">Start Date</TableCell>
                    <TableCell className="tableHeadStyle">Appt Status</TableCell>
                    <TableCell className="tableHeadStyle">Type</TableCell>
                    <TableCell className="tableHeadStyle">Location</TableCell>
                    <TableCell className="tableHeadStyle">Provider</TableCell>
                    <TableCell className="tableHeadStyle">Visit Type</TableCell>
                    <TableCell className="tableHeadStyle">Reason for Visit</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {!props.loader && props.appointmentData &&
                    props.appointmentData.map((data, i) => (
                        <TableRow
                            key={i}
                            className={props.documentLevel === "Encounter" && props.selectedAppointment === data.identifier ? "ehr-table-row-color" : "table-row"}
                        >
                            <TableCell className="tableCellStyle" align="left">
                                <Checkbox
                                    size="small"
                                    checked={props.documentLevel === "Encounter" && props.selectedAppointment === data.identifier ? true : false }
                                    onChange={(event) => props.handleAppointmentSelection(event, data)}
                                    disabled={props.documentLevel !== "Encounter"}
                                />
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {data.s_no}
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {data.identifier}
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {FormatDate({ date: data.start, format: "MM/DD/YYYY" })}
                            </TableCell>
                            <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">    
                                {data?.status?.charAt(0).toUpperCase() + data?.status?.slice(1)}
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {data?.resourceType}
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {(data.participant || []).filter(participant => participant?.actor?.reference?.toLowerCase().includes('location')).map(res=> res?.actor?.display)}
                            </TableCell>  
                            <TableCell className="tableCellStyle" align="left">
                                {(data.participant || []).filter(participant => participant?.actor?.reference?.toLowerCase().includes('practitioner')).map(res=> res?.actor?.display)}
                            </TableCell>
                            <TableCell className="tableCellStyle" style={{ whiteSpace: "nowrap" }} align="left">
                                {data?.serviceType}
                            </TableCell>
                            <TableCell className="tableCellStyle" align="left">
                                {data?.reasonCode}
                            </TableCell>
                        </TableRow>
                    ))}
            </TableBody>

        </Table>
        {props.loader ? <CircularProgress size={30} className="popup-spinner" /> : (props.appointmentData?.length === 0 && <DialogModel /> || null)}
    </TableContainer>
    <TablePage
        count={props.pagination.totalRecords}
        recordsPerPage={props.pagination.recordsPerPage}
        pageNum={props.pagination.currentPage}
        handleChangePage={props.handleChangePage}
    />
</div>
}

export default EhrAppointmentsTable;